import _defineProperty from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/** This function adds duration since Sentry was initialized till the time event was sent */
var SessionTiming =
/*#__PURE__*/
function () {
  _createClass(SessionTiming, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'SessionTiming';
    }
    /**
     * @inheritDoc
     */

    /** Exact time Client was initialized expressed in milliseconds since Unix Epoch. */

  }]);

  function SessionTiming() {
    _classCallCheck(this, SessionTiming);

    this.name = SessionTiming.id;
    this._startTime = Date.now();
  }
  /**
   * @inheritDoc
   */


  _createClass(SessionTiming, [{
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      addGlobalEventProcessor(function (event) {
        var self = getCurrentHub().getIntegration(SessionTiming);

        if (self) {
          return self.process(event);
        }

        return event;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "process",
    value: function process(event) {
      var _objectSpread2;

      var now = Date.now();
      return _objectSpread({}, event, {
        extra: _objectSpread({}, event.extra, (_objectSpread2 = {}, _defineProperty(_objectSpread2, 'session:start', this._startTime), _defineProperty(_objectSpread2, 'session:duration', now - this._startTime), _defineProperty(_objectSpread2, 'session:end', now), _objectSpread2))
      });
    }
  }]);

  return SessionTiming;
}();

SessionTiming.__initStatic();

export { SessionTiming };